const Airtable = require('airtable');

export default class AirtableBase {
    apiKey: string;
    base: string;
    endpointUrl: string;
    instance: any;

    constructor(apiKey: string, base: string, endpointUrl?: string) {
        this.apiKey = apiKey;
        this.base = base;
        this.endpointUrl = endpointUrl || 'https://api.airtable.com';

        this.instance = new Airtable({
            apiKey: this.apiKey,
            endpointUrl: this.endpointUrl,
        }).base(this.base);
    }

    /**
     * Reconfigure the Airtable instance with new credentials.
     * Called after obtaining a proxy JWT to switch from direct access to proxy.
     */
    reconfigure(apiKey: string, endpointUrl?: string) {
        this.apiKey = apiKey;
        if (endpointUrl) this.endpointUrl = endpointUrl;

        this.instance = new Airtable({
            apiKey: this.apiKey,
            endpointUrl: this.endpointUrl,
        }).base(this.base);
    }
}
